var Shape = require('../core/shape');

Shape.Arc = require('./arc');
Shape.Circle = require('./circle');
Shape.Dom = require('./dom');
Shape.Ellipse = require('./ellipse');
Shape.Fan = require('./fan');
Shape.Image = require('./image');
Shape.Line = require('./line');
Shape.Marker = require('./marker');
Shape.Path = require('./path');
Shape.Polygon = require('./polygon');
Shape.Polyline = require('./polyline');
Shape.Rect = require('./rect');
Shape.Text = require('./text');
module.exports = Shape;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/g/lib/shapes/index.js
// module id = 226
// module chunks = 0 1 2